{
  "form": {
    "username": {},
    "password": {},
    "login": {}
  }
}
